const GMAIL_TOOLS = new Set([
  'list_emails',
  'read_email',
  'search_emails',
  'send_email',
  'reply_to_email',
])

export const TOOL_CATEGORIES = ['HubSpot', 'Gmail', 'Outlook', 'Web Search', 'General', 'Other'] as const
export type ToolCategory = (typeof TOOL_CATEGORIES)[number]

export function toolCategory(toolName: string): ToolCategory {
  if (toolName.startsWith('hubspot_')) return 'HubSpot'
  if (toolName.endsWith('_outlook')) return 'Outlook'
  if (GMAIL_TOOLS.has(toolName)) return 'Gmail'
  if (toolName === 'web_search') return 'Web Search'
  if (toolName === 'get_current_date') return 'General'
  return 'Other'
}
